<template>
  <div id="home">
    <div class="box">
      <img class="home-img" src="images/ETC/homeBg.jpg" alt="">
      <div class="text">
      <pre>无需充值，零等待，线上办理，走ETC专用
通道先通行后扣费，还可以享受高速通行费
折扣。

交通部规定，1辆车仅允许办理1张ETC卡，
专车专用。
      </pre>
      </div>
      <div class="button" @click="toETCList">马上申请</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "index",
    methods:{
      toETCList() {
        this.$router.push('/ETC/list')
      },
    }
  }
</script>

<style scoped>
  #home{
    width: 100vw;
    background: linear-gradient(to bottom, #fb7e5d 50%, #fa5448 50%);
    position: relative;
    display: flex;
    align-items: center;
  }
  .box{
    position: relative;
  }
  .home-img{
    width: 100%;
  }
  .text{
    width: 71vw;
    color: white;
    position: absolute;
    top: 95vw;
    left: 14vw;
    font-size: 3.8vw;
  }
  .button{
    width: 81.867vw;
    height: 12.667vw;
    text-align: center;
    color: white;
    font-size: 4.3vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    position: absolute;
    top: 132.8vw;
    left: 9.067vw;
  }
</style>
